import type {
  UseGetUseVendorMaterialPricingPlanCalculationQueryKey,
  VendorMaterialPricingPlanCalculationRequest,
} from './types';

export const getUseVendorMaterialPricingPlanCalculationQueryKey = (
  data: VendorMaterialPricingPlanCalculationRequest,
): UseGetUseVendorMaterialPricingPlanCalculationQueryKey => [
  'vendors',
  'vendorMaterialPricingPlanCalculation',
  data,
];
